var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4372 18.5792L12 14.1421L7.56284 18.5792C7.28233 18.8597 6.92532 19 6.4918 19C6.05829 19 5.70127 18.8597 5.42076 18.5792C5.14025 18.2987 5 17.9417 5 17.5082C5 17.0747 5.14025 16.7177 5.42076 16.4372L9.85792 12L5.42076 7.56284C5.14025 7.28233 5 6.92532 5 6.4918C5 6.05829 5.14025 5.70127 5.42076 5.42076C5.70127 5.14025 6.05829 5 6.4918 5C6.92532 5 7.28233 5.14025 7.56284 5.42076L12 9.85792L16.4372 5.42076C16.7177 5.14025 17.0747 5 17.5082 5C17.9417 5 18.2987 5.14025 18.5792 5.42076C18.8597 5.70127 19 6.05829 19 6.4918C19 6.92532 18.8597 7.28233 18.5792 7.56284L14.1421 12L18.5792 16.4372C18.8597 16.7177 19 17.0747 19 17.5082C19 17.9417 18.8597 18.2987 18.5792 18.5792C18.2987 18.8597 17.9417 19 17.5082 19C17.0747 19 16.7177 18.8597 16.4372 18.5792Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.7302895074148c238aa3301998e93711.svg";
export { ForwardRef as ReactComponent };